import React from 'react';
export function CTASection() {
  return <div className="bg-red-50 p-5 sm:p-8 rounded-lg my-10 border border-red-100 shadow-sm" data-id="element-99">
      <h3 className="font-bold text-xl mb-4 text-red-700" data-id="element-100">
        Watch the Free Video Now
      </h3>
      <p className="mb-6 text-lg" data-id="element-101">
        Discover how to reactivate his neurotransmitters and make him beg to
        come back.
      </p>
      <a href="https://mindinfonow.online/vsl-drmw-01?src=advdrmw2" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-md flex items-center justify-center w-full text-base sm:text-lg shadow-md transition-all hover:shadow-lg hover:scale-105 active:scale-95 no-underline cursor-pointer" data-id="element-102">
        <span className="mr-2" data-id="element-103">👉</span> Click Here to Watch →
      </a>
    </div>;
}